import { init as initApm } from '@elastic/apm-rum';

import config from '../config';

function initializeApm() {
  initApm({
    environment: config.ENVIRONMENT,
    serviceName: config.APM_SERVICE_NAME,
    serverUrl: config.APM_SERVER_URL,
    serviceVersion: process.env.BUILD_ID || 'development',
  });
}

initializeApm();
